import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { ADD_TASK, DELIVERY_TYPE_SEARCH, LANGUAGES_SEARCH, DRIVER_TYPE_SEARCH } from "helpers/api_endpoints";
import GoogleMapReact from 'google-map-react';
import MapComponent from "../../components/Common/Map"
import Select from "react-select";


//meta title
document.title = "Add Task";

const AddTask = () => {

	const [name, setName] = useState('');
	const [deliveryTypes, setDeliveryTypes] = useState([]);
	const [driverTypes, setDriverTypes] = useState([]);
	const [deliveryTypeId, setDeliveryTypeId] = useState('');
	const [driverTypeId, setDriverTypeId] = useState('');
	const [actionTypeId, setActionTypeId] = useState('');
	const [addressType, setAddressType] = useState({value:1,label:"Pickup"});
	const [addressTypes, setAddressTypes] = useState([{value:1,label:"Pickup"}, {value:2,label:"Drop"}]);
	const [status, setStatus] = useState(0);
	const [relateToOrder, setRelateToOrder] = useState(1);
    const [valued, setValued] = useState({"title":[]});
	const [languages, setLanguages] = useState([]);
	const [errorMsg, seterrorMsg] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		// successMessage();
		post(`${DELIVERY_TYPE_SEARCH}`)
			.then(response => {
				const data = response.data.map((el,index)=>{
					return {value:el.id,label:el.name}; 
				});
				setDeliveryTypes(data);
				// setLoading(false);
			})
			.catch(error => {
				console.log(error)
				if (error.response.status == 400) {
					navigate('/logout');
				}
			})
	}, []);

	useEffect(() => {
		post(`${LANGUAGES_SEARCH}`,{status:1})
			.then(response => {
				setLanguages(response.data);
				// setLoading(false);
			})
			.catch(error => {
				console.log(error)
			})
		post(`${DRIVER_TYPE_SEARCH}`)
			.then(response => {
				const data = response.data.map((el,index)=>{
					return {value:el.id,label:el.name}; 
				});
				setDriverTypes(data);
				// setLoading(false);
			})
			.catch(error => {
				console.log(error)
				if (error.response.status == 400) {
					navigate('/logout');
				}
			})
	}, []);

	const handleSubmit = () => {
		post(ADD_TASK, { name, deliveryTypeId, addressType, relateToOrder, status, driverTypeId, actionTypeId })
			.then(response => {
				if (response.code == 201) {
					navigate('/tasks', { state: { successMsg: 'Task Added SuccessFully' } });
				}
			})
			.catch(error => {
				seterrorMsg('Task Creation Failed');
			})
	}

    const handleName = (languageId,value) => {
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }
	const handleFilter = (type,value) => {
		switch(type)
		{
			case 'deliveryTypeId':
				{
					setDeliveryTypeId(value);
					break;
				}
			case 'addressType':
				{
					setAddressType(value);
					break;
				}
            case 'name':
                {
                    break;
                }
			default:
				break;
		}

	}

	return (
		<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<Breadcrumbs title="Countries" breadcrumbItem="Add Task" />
					<Form
						className="form-horizontal"
						onSubmit={(e) => {
							e.preventDefault();
							handleSubmit();
							return false;
						}}
					>
						<Row>
							<Col xl={12}>
								<Card>
									<CardBody>
										<Row>
											{errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
											{
												languages.map((language, index) => (
													<Row key={index}>
													<div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            // value={name}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required={language.id==1||language.id==2?true:false} ></Input>
                                                    </div>
												</Row>
                                                ))
											}
											
											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Action ID</Trans></Label>
												<Input
													name="actionTypeId"
													value={actionTypeId}
													className="form-control"
													placeholder="Enter  Name"
													type="text"
													onChange={(e) => setActionTypeId(e.target.value)}
													></Input>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Delivery Type</Trans></Label>
												<Select
													name="deliveryTypeId"
													options={deliveryTypes} 
													className="form-control select2"
													onChange={(e) => handleFilter('deliveryTypeId', e.value)}
													/>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Address Type</Trans></Label>
												<Select
													name="addressType"
													options={addressTypes} 
													className="form-control select2"
													onChange={(e) => handleFilter('addressType', e.value)}
													/>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Status</Trans></Label>
												<select className="form-control" onChange={(e) => setStatus(e.target.value)}>
													<option value=''></option>
													<option value={1} selected={status == 1}><Trans>Active</Trans></option>
													<option value={0} selected={status == 0}><Trans>Non Active</Trans></option>
												</select>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Relate to order</Trans></Label>
												<select className="form-control" onChange={(e) => setRelateToOrder(e.target.value)}>
													<option value=''></option>
													<option value={1} selected={relateToOrder == 1}><Trans>Yes</Trans></option>
													<option value={2} selected={relateToOrder == 2}><Trans>No</Trans></option>
												</select>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Driver Type</Trans></Label>
												<Select className="form-control" 
													name="addressType"
													options={driverTypes} 
													value={driverTypes.filter(el => el.value == driverTypeId)}
													onChange={(e) => setDriverTypeId(e.value)} />											
											</div>

										</Row>
										<div className="text-center  mt-4">
											<Button type="submit" color="danger">
												<Trans>Submit</Trans>
											</Button>
										</div>
									</CardBody>
								</Card>
							</Col>
							<Col xl={12}>
								<Row>

								</Row>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
		</React.Fragment>
	)
}

export default AddTask
